export enum DatetimeVariantEnum {
  COLUMN = 'column',
}
